import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import TableCopiarActividades from "./TableCopiarActividades";
import ConfirmBtn from "../ConfirmBtn";
import Cookies from "universal-cookie";
const BtnCopiarActividades = ({ copyDataProp, selectedActivityProp, messageSelectionProp, setExecutedOnHideProp }) => {

    const cookies = new Cookies();
    var idProveedor = cookies.get('idProveedor');
    const [displayBasic, setDisplayBasic] = useState(false);
    const [validateChange, setValidateChange] = useState(false);
    const [permisoRegistrar, setPermisoRegistrar] = useState(false);
    const [dataCopiedRegister, setDataCopiedRegister] = useState([]);

    const [setPosition] = useState('center')

    const dialogFuncMap = {
        'displayBasic': setDisplayBasic
    }

    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);

        if (position) {
            setPosition(position);
        }
        setExecutedOnHideProp(false)
    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false)
        setExecutedOnHideProp(true)
    }

    const ModalRegresar = () => {
        const [displayConfirmation, setDisplayConfirmation] = useState(false);

        const [setPosition] = useState('center');

        const dialogFuncMap = {
            'displayConfirmation': setDisplayConfirmation
        }

        const onClick = (name, position) => {
            dialogFuncMap[`${name}`](true);

            if (position) {
                setPosition(position);
            }
        }

        const onHide = (name) => {
            dialogFuncMap[`${name}`](false);
        }

        const Regresar = (name) => {
            setDataCopiedRegister([])
            setValidateChange(false)
            setDisplayBasic(false)
            setDisplayBasic(false)
            dialogFuncMap[`${name}`](false);
        }

        const renderFooter = (name) => {
            return (
                <div>
                    <Button label="Cancelar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                    <Button label="Aceptar" icon="pi pi-check" onClick={() => Regresar(name)} autoFocus />
                </div>
            );
        }
        return (
            <>
                <Button label="Regresar" icon="pi pi-times" onClick={() => onClick('displayConfirmation')} className="p-button-text" />
                <Dialog className="dialog-demo" header="Advertencia" visible={displayConfirmation} modal style={{}}
                    footer={renderFooter('displayConfirmation')} onHide={() => ('displayConfirmation')}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                        <span style={{ textAlign: 'center' }}>No se ha guardado información registrada, ¿desea continuar?</span>
                    </div>
                </Dialog>
            </>
        )
    }

    var arrayDataMap = dataCopiedRegister.map(item => {
        return [JSON.stringify(item), item]
    })
    var arrayDataMapArr = new Map(arrayDataMap)
    var uniqueData = [...arrayDataMapArr.values()]
    const renderFooter = (name) => {
        return (
            <>
                {validateChange ?
                    <ModalRegresar />
                    :
                    <Button label="Regresar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                }
                {permisoRegistrar ?
                    dataCopiedRegister.length !== 0
                        ?
                        <ConfirmBtn
                            titulo="Copiar Registro"
                            mensaje="¿Señor usuario desea registrar las actividades en las fechas seleccionadas?"
                            accion="Registrar"
                            label="Guardar"
                            icono="pi pi-pencil"
                            dataProp={uniqueData}
                            indicadorProp={0}
                            idProveedorProp={idProveedor}
                        />
                        :
                        ""
                    :
                    ''
                }
            </>
        );
    }
    /* console.log(uniqueData) */
    const newArrayActivities = copyDataProp === null ? [] : copyDataProp.map(item => {
        return {
            fecha: item.sendDate,
            actualizadopor: item.actualizadopor,
            aplicacion: item.aplicacion,
            areanegocio: item.areanegocio,
            cliente: item.cliente,
            colaborador: item.colaborador,
            coordinadocon: item.coordinadocon,
            creadopor: item.creadopor,
            descripcionactividad: item.descripcionactividad,
            esadicional: item.esadicional,
            estado: item.estado,
            fechaactualizado: item.fechaactualizado,
            fechacorreoelec: item.fechacorreoelec,
            fechacreacion: item.fechacreacion,
            idempresa: item.idempresa,
            notas: item.notas,
            id: item.id,
            numerohoras: item.numerohoras,
            proyecto: item.proyecto,
            tipoActividad: item.tipoActividad,
            ticket: item.ticket
        }
    })
    return (
        <>
            <Button label="Copiar Actividades" icon="pi pi-clone" onClick={() => onClick('displayBasic')}
                className="p-button-warning" />

            {
                selectedActivityProp ?
                    <Dialog className="modal" header="Copiar Actividades" visible={displayBasic} onHide={() => onHide('displayBasic')}
                        footer={renderFooter('displayBasic')}>
                        <div className="datatable-responsive-demo">
                            <div className="card">
                                <TableCopiarActividades
                                    copyDataProp={newArrayActivities}
                                    validateChangeProp={setValidateChange}
                                    permisoRegistrarProp={setPermisoRegistrar}
                                    setDataCopiedRegisterProp={setDataCopiedRegister}
                                    dataCopiedRegisterProp={dataCopiedRegister}
                                    uniqueDataProp={uniqueData}
                                />
                            </div>
                        </div>
                    </Dialog>
                    :
                    <Dialog className="dialog-demo" visible={displayBasic} header="Advertencia" onHide={() => onHide('displayBasic')}
                        footer={<Button label="Entendido" icon="pi pi-check" onClick={() => onHide('displayBasic')} />}>
                        <div className="confirmation-content">
                            <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                            <span>{messageSelectionProp}</span>
                        </div>

                    </Dialog>
            }
        </>
    )
}

export default BtnCopiarActividades